export default __webpack_public_path__ + "right-bg5970f95.png";